//@ts-nocheck
/* 
 *  This file auth-service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";

import { forkJoin, Observable, Subject } from "rxjs";
import { catchError, first, tap } from "rxjs/operators";

import { ConfigurationService } from "./configuration.service";
import { superUserMenuNavigationModel } from "../constants/routing-constant";
import { SharedService } from "./shared.service";
import { SuperUserServerErrorHandlerService } from "./error-handler/super-user-server-error-handler.service";

@Injectable()
export class AuthService {
  chat_base_url;
  refresh_token;
  domainCode;
  base_url;
  redirect_to_hrone_app;
  onLogout$ = new Subject();
  employeeInfoAfterLogin = null;
  superUserInfoAfterLogin = null;
  onloggedInEvent = new EventEmitter();
  onCloseDialogEvent = new EventEmitter();

  constructor(
    private _httpClient: HttpClient,
    public _router: Router,
    private _serverError: SuperUserServerErrorHandlerService,
    public _config: ConfigurationService,
    private _shared: SharedService
  ) {
    this.domainCode = _config.domainCode;
    this.base_url = _config["base_url"];
    this.chat_base_url = _config["chat_base_url"];
    this.redirect_to_hrone_app = _config["redirect_to_hrone_app"];
  }

  getHeaders() {
    const authlogin = JSON.parse(localStorage.getItem("authlogin"));
    const accessToken = authlogin ? authlogin.access_token : "";
    return new HttpHeaders({
      "Content-Type": "application/json",
      domainCode: this.domainCode,
      Authorization: "Bearer " + accessToken,
      AccessMode: 'W'
    });
  }

  public Get(url): Observable<any> {
    return this._httpClient
      .get(this.base_url + url, { headers: this.getHeaders() })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }

  public Post(url, param): Observable<any> {
    return this._httpClient
      .post(this.base_url + url, param, { headers: this.getHeaders() })
      .pipe(catchError(err => this._serverError.handleServerError(err)));
  }

  public PostUnAuthorize(url, param): Observable<any> {
    console.log("post unauth", url, param);
    const headers = this.getHeaders();
    headers.delete("Authorization");
    return this._httpClient
      .post(this.base_url + url, param, { headers: headers })
      .pipe(catchError(err => this._serverError.handleServerError(err, 'isUnauthorize')));
  }

  setLoginAuth(data) {
    localStorage.setItem("authlogin", JSON.stringify(data));
    // for refresh token
    const start_token_time = new Date().getTime() / 1000; // in sec
    localStorage.setItem("start_token_time", JSON.stringify(start_token_time));
    const refresh_in = data.expires_in - 120; // in sec
    console.log("refresh_in from login", refresh_in);
    if (refresh_in > 0) {
      this.callRefreshToken(refresh_in);
    }
    // end
  }

  // check on window reload
  refreshTokenOnWindowReload() {
    if (
      localStorage.getItem("authlogin") &&
      localStorage.getItem("start_token_time")
    ) {
      const current_time = new Date().getTime() / 1000;
      const start_token_time = Number(localStorage.getItem("start_token_time"));
      const refresh_time =
        JSON.parse(localStorage.getItem("authlogin")).expires_in - 120;
      const refresh_in = refresh_time - (current_time - start_token_time);
      console.log("refresh_in from app", refresh_in);
      if (refresh_in > 0) {
        this.callRefreshToken(refresh_in);
      } else {
        this.logout();
      }
    }
  }

  // check on authguard
  isAuthenticated() {
    // for refresh token
    if (
      localStorage.getItem("authlogin") &&
      localStorage.getItem("start_token_time")
    ) {
      return true;
    }
    return false;
    // end
  }

  callRefreshToken(time) {
    if (this.refresh_token) {
      clearTimeout(this.refresh_token);
    }
    this.refresh_token = setTimeout(() => {
      this.getRefreshToken();
    }, time * 1000);
  }

  getRefreshToken() {
    const authlogin = JSON.parse(localStorage.getItem("authlogin"));
    const url = "/oauth2/token";
    const body =
      "refresh_token=" +
      authlogin.refresh_token +
      "&companyDomainCode=" +
      this.domainCode +
      "&grant_type=" +
      "refresh_token";
    this.PostUnAuthorize(url, body).subscribe(
      res => {
        console.log("resp ", res);
        this.setLoginAuth(res);
      },
      err => {
        setTimeout(() => {
          this.refreshTokenOnWindowReload();
        }, 5000);
      }
    );
  }

  logout() {
    try {
      if (localStorage.getItem('authlogin')) {
        const authlogin = JSON.parse(localStorage.getItem("authlogin"));
        const accessToken = authlogin ? authlogin.access_token : "";
        if (this._shared.supportUserInfo && this._shared.supportUserInfo.supportUserLoginId && this._shared.supportUserInfo.mappedUserId) {
          this.logOutFromSupportUser(accessToken);
        }
      }
      localStorage.removeItem('authlogin');
      localStorage.removeItem('rawMenusWithActions');
      localStorage.removeItem('socketId');
      localStorage.removeItem('rawMenus');
      localStorage.removeItem('start_token_time');
      localStorage.removeItem('logOnUserDetails');
      localStorage.removeItem('whiteLabels');
      localStorage.removeItem('userChatId');
      localStorage.removeItem('uid');
      localStorage.removeItem('GC_Accesstoken');
      const isExternalLogin = JSON.parse(localStorage.getItem('isExternal'))
      if(isExternalLogin){
        this._router.navigate(['/login']);
      }else{
        this._router.navigate(['/product-management/login']);
      }
    } catch (err) { }
    this.onLogout$.next(Math.random());
  }

  logOutFromSupportUser(accessToken) {
    if (accessToken) {
      try {
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
          domainCode: this.domainCode,
          Authorization: "Bearer " + accessToken,
          AccessMode: 'W'
        });
        const supportUser = encodeURIComponent(this._shared.supportUserInfo.supportUserLoginId);
        const mappedUser = encodeURIComponent(this._shared.supportUserInfo.mappedUserId);
        this._httpClient
          .post(this.base_url + `/api/support/logOff?supportUserLoginId=${supportUser}&domainCode=${this._shared.supportUserInfo.domainCode}&mappedUserId=${mappedUser}`, '', {
            headers: headers
          })
          .subscribe(res => {
            console.log("logoutttt", res);
            this._shared.supportUserInfo = null;
          });
      } catch (err) {
        console.log('web log out error', err);
      }
    }
  }

  getSuperUserOtherInfo(): any {
    const userName = JSON.parse(localStorage.getItem('authlogin')).userName;
    return new Promise((resolve, reject) => {
      const MenuModelObject = {
        menuType: '',
        parentKey: 9999,
        menuId: 0
      };
      const menuList = this.Post('/api/superuser/logOn', MenuModelObject);
      const superUserDetails = this.Get('/api/superuser/Details?superUserId=' + userName);
      this.Get('/api/superuser/logOn/UserDetail').toPromise().then(() => {
        this.superUserInfoAfterLogin = true;
        forkJoin([menuList, superUserDetails])
          .pipe(
            first(),
            tap(data => {
              superUserMenuNavigationModel.forEach(item => {
                try {
                  data[0].find(e => e.navigationCode === item.code).navigationPath = item.path;
                } catch (e) { }
              });
              this._shared.superUserLogOnDetails = data[1];
              this._shared.superUserMenuList = data[0];
              localStorage.setItem('superUserAccessRights', JSON.stringify(data[0]));
              localStorage.setItem('superUserLogOnDetails', JSON.stringify(data[1]));
              resolve(true);
            })
          ).toPromise().then(data => { }).catch(err => {
            reject(false);
          });

      }).catch(err => {
        reject(false);
      });
    });
  }
}